"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MediaWrapper = void 0;

var tslib_1 = require("tslib");

var ui_flex_1 = require("@hopin-team/ui-flex");

var styled_components_1 = tslib_1.__importDefault(require("styled-components"));

exports.MediaWrapper = (0, styled_components_1.default)(ui_flex_1.Flex)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  width: 100%;\n  justify-content: ", ";\n"], ["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  width: 100%;\n  justify-content: ", ";\n"])), function (_a) {
  var hasBadge = _a.hasBadge,
      hasHalon = _a.hasHalon,
      isSingle = _a.isSingle;

  if (isSingle) {
    if (hasHalon) return 'start';
    if (hasBadge) return 'space-between';
  }

  return 'space-between';
});
var templateObject_1;